import React from 'react'
import styled from 'styled-components'

const Preview = () => {
  return <Wrapper></Wrapper>
}

export default Preview

const Wrapper = styled.div`
  width: 375px;
  min-height: calc(100dvh - 250px);
  border: 1px solid black;
  border-radius: 10px;
  padding-left: 16px;
  box-sizing: border-box;
  background-color: #f8f8f8;
  overflow-y: auto;
  scrollbar-color: transparent transparent;
  scrollbar-width: 0;
  -ms-overflow-style: none;
  flex-shrink: 0;

  &::-webkit-scrollbar {
    width: 0;
    display: none;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
    border: none;
  }
`
